// personalisatie-velden.js
// Toont/verbergt automatisch het upload- en tekstveld (Globo Product Options)
// op basis van de gekozen 'Personalisatie' variant-optie.
// Werkt voor alle producten die de gedeelde optieset 'Logo en tekst op gebak' gebruiken.
// v2: herordent de rechterkolom (Staffelkorting - Aantal - Personalisatie - Winkelwagen),
// zet het minimale/standaard aantal op 25 en maakt het Personalisatieblok visueel opvallend.
// Versie 2 - 6 sept 2026
// v3: de verplaatste keuzelijst 'Personalisatie' stuurt ook de (verborgen) themakeuze in variant-radios aan,
// zodat gekozen uitvoering, getoonde prijs en winkelwagenprijs altijd overeenkomen (zie zetVariant).
// Versie 3 - 08-10-2026
(function () {
function syncVelden(select) {
var fileVeld = document.querySelector('.gpo-element[data-element-id="file-1"]');
var tekstVeld = document.querySelector('.gpo-element[data-element-id="text-1"]');
if (!fileVeld || !tekstVeld) return;
var waarde = select.value;
var toonFoto = (waarde === 'Logo of foto' || waarde === 'Logo of foto + tekst');
var toonTekst = (waarde === 'Alleen tekst' || waarde === 'Logo of foto + tekst');
fileVeld.style.display = toonFoto ? '' : 'none';
tekstVeld.style.display = toonTekst ? '' : 'none';
}

// v3 (08-10-2026): sinds v2 staat de keuzelijst buiten <variant-selects>, waardoor het thema de keuze niet meer
// hoorde en de variant op 'Alleen tekst' bleef (te lage prijs). Het thema werkt de variant (id, prijs, adres) wél bij
// via de verborgen keuzeknoppen in <variant-radios>. Daarom: bij elke keuze precies die knop aanvinken en het
// gewone 'change'-signaal sturen; het thema doet de rest. Zonder bijpassende knop: niets doen (ongewijzigd gedrag).
function zetVariant(waarde) {
var knoppen = document.querySelectorAll('input[name="Personalisatie"]');
var doel = null;
for (var i = 0; i < knoppen.length; i++) { if (knoppen[i].value === waarde) { doel = knoppen[i]; break; } }
if (!doel || doel.checked) return;
// lusbeveiliging: dezelfde keuze hooguit 3 keer per 5 seconden doorgeven
var nu = Date.now();
if (zetVariant.w !== waarde || nu - zetVariant.t > 5000) { zetVariant.w = waarde; zetVariant.t = nu; zetVariant.n = 0; }
if (++zetVariant.n > 3) return;
doel.checked = true;
doel.dispatchEvent(new Event('change', { bubbles: true }));
}

var MIN_AANTAL = 25;
var herordendPogingen = 0;

function herordenEnStyle() {
var container = document.querySelector('.product__info-container, .product-info');
var buttons = document.querySelector('.product-form__buttons');
var select = document.querySelector('select[name="options[Personalisatie]"]');
if (!container || !buttons || !select) {
herordendPogingen++;
if (herordendPogingen < 100) setTimeout(herordenEnStyle, 100);
return;
}
if (buttons.dataset.jtHerordend) return;
buttons.dataset.jtHerordend = '1';

var variantSelects = container.querySelector('variant-selects');
var staffelAccordion = container.querySelector('.jt-staffel-accordion');
if (staffelAccordion && variantSelects && variantSelects.parentNode) {
variantSelects.parentNode.insertBefore(staffelAccordion, variantSelects);
}

var quantityBlock = buttons.querySelector('.product-form__quantity');
var gpoContainer = buttons.querySelector('.gpo-container');
var personalisatieDiv = select.closest('.product-form__input');
if (personalisatieDiv && gpoContainer && gpoContainer.parentNode) {
gpoContainer.parentNode.insertBefore(personalisatieDiv, gpoContainer);
} else if (personalisatieDiv && quantityBlock && quantityBlock.parentNode) {
quantityBlock.parentNode.insertBefore(personalisatieDiv, quantityBlock.nextSibling);
}
if (personalisatieDiv) {
personalisatieDiv.style.border = '2px solid #866A47';
personalisatieDiv.style.borderRadius = '6px';
personalisatieDiv.style.padding = '12px';
personalisatieDiv.style.marginBottom = '12px';
personalisatieDiv.style.background = 'rgba(134, 106, 71, 0.08)';
}

var qtyInput = document.querySelector('input[name="quantity"]');
if (qtyInput) {
qtyInput.setAttribute('min', String(MIN_AANTAL));
var huidig = parseInt(qtyInput.value, 10);
if (isNaN(huidig) || huidig < MIN_AANTAL) {
qtyInput.value = MIN_AANTAL;

}
}
}

function initPersonalisatie() {
var select = document.querySelector('select[name="options[Personalisatie]"]');
if (!select) return;
if (!select.dataset.personalisatieGekoppeld) {
select.dataset.personalisatieGekoppeld = '1';
select.addEventListener('change', function () {
syncVelden(select);
zetVariant(select.value);
});
}
syncVelden(select);
zetVariant(select.value);   // v3: bij laden/terugkeren (browsergeheugen) keuzelijst en variant gelijk trekken
herordenEnStyle();
}

document.addEventListener('DOMContentLoaded', initPersonalisatie);
var observer = new MutationObserver(initPersonalisatie);
observer.observe(document.documentElement, { childList: true, subtree: true });
})();
// Versie 3 - 08-10-2026 - personalisatie-velden.js - keuzelijst Personalisatie stuurt variant-radios aan (juiste variant en prijs); verder gelijk aan Versie 2
